import React, { useState } from "react";
import emailjs from "@emailjs/browser";

export default function ContactSection() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(""); // success or error

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_3kgo1hh",
        "template_dpdbbcx",
        {
          from_name: formData.name,
          reply_to: formData.email,
          message: formData.message,
        },
        "z4Gp7WLqrxKHB0Yul"
      )
      .then(() => {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
        setTimeout(() => setStatus(""), 5000);
      })
      .catch((err) => {
        console.error("Email send error:", err);
        setStatus("error");
      });
  };

  return (
    <section
      id="contact"
      className="w-full bg-light dark:bg-dark py-24 text-black dark:text-white"
    >
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex items-baseline gap-4 mb-12">
          <span className="font-mono text-[13px] text-accent">04</span>
          <h2 className="text-3xl font-bold tracking-tight">Contact</h2>
          <span className="flex-1 h-px bg-black/10 dark:bg-white/10" />
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left: pitch */}
          <div>
            <p className="font-mono text-[13px] uppercase tracking-wider text-accent mb-4">
              Get in touch
            </p>
            <h3 className="text-3xl sm:text-4xl font-bold leading-tight mb-5">
              Let&apos;s build something solid.
            </h3>
            <p className="text-lg text-muted dark:text-pale max-w-md">
              Have a Niagara integration, a driver, or a front-end project in mind?
              Drop me a line and I&apos;ll get back to you.
            </p>
          </div>

          {/* Right: form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block mb-2 font-mono text-[12px] uppercase tracking-wider text-muted dark:text-pale">
                Name
              </label>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 rounded-md border border-black/15 dark:border-white/15 bg-white dark:bg-[#101315] focus:outline-none focus:border-accent transition-colors"
              />
            </div>
            <div>
              <label className="block mb-2 font-mono text-[12px] uppercase tracking-wider text-muted dark:text-pale">
                Email
              </label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 rounded-md border border-black/15 dark:border-white/15 bg-white dark:bg-[#101315] focus:outline-none focus:border-accent transition-colors"
              />
            </div>
            <div>
              <label className="block mb-2 font-mono text-[12px] uppercase tracking-wider text-muted dark:text-pale">
                Message
              </label>
              <textarea
                name="message"
                rows="5"
                required
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 rounded-md border border-black/15 dark:border-white/15 bg-white dark:bg-[#101315] focus:outline-none focus:border-accent transition-colors"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-accent text-light py-3 rounded-md font-mono text-[13px] hover:opacity-90 transition"
            >
              Send message →
            </button>

            {status === "success" && (
              <p className="text-accent text-center pt-1 font-medium">
                Message sent successfully.
              </p>
            )}
            {status === "error" && (
              <p className="text-red-500 text-center pt-1 font-medium">
                Something went wrong, please try again.
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
